export const AgentPrincipalOrganisationUseCaseStatus = {
	  ENABLED: 'ENABLED',
	  DISABLED: 'DISABLED',
	  PENDING_ENABLE_APPROVAL: 'PENDING_ENABLE_APPROVAL',
	  PENDING_DISABLE_APPROVAL: 'PENDING_DISABLE_APPROVAL',
}
